module.exports = __webpack_public_path__ + "img/ms.42fde26e.png";